<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2021/06/11

    Historial de Modificaciones
    // Fecha Modificación: 
    // Modificación: 

    ///////////////////////////////////////////////////////////
-->

<template>
  <div>
    <v-row class="pt-2" v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse">
        <TableButtonComp @click="modalAddExperiencia()" textButton="Agregar experiencia laboral" iconBut="fas fa-plus"
          normalButton />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" v-if="mensajeExperiencia">
        <v-card outlined>
          <v-card-text style="height:500px" class="text-center d-flex justify-center align-center">
            <span class="">
              Aún no has agregado ninguna experiencia laboral
            </span>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <v-row>
      <v-col v-for="item in experienciaItem" :key="item.name" cols="12" md="6" sm="6" xs="12 "
        class="d-flex justify-center">
        <v-card outlined flat width="400px">
          <v-alert border="top" colored-border color="#0277bd" elevation="4" class="my-0" icon="fas fa-certificate">
            <v-row align="center">
              <v-col cols="12" md="10" xs="12">
                <v-row>
                  <v-col cols="12">
                    <span class="font-weight-black">
                      <h3>{{ item.cargo_experiencia }}</h3>
                    </span>
                    <v-divider />
                  </v-col>
                  <v-col cols="5" class="py-0">
                    <span class="font-weight-bold">Empresa: </span>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    {{ item.nombre_empresa }}
                  </v-col>
                  <v-col cols="5" class="py-0">
                    <span class="font-weight-bold">Sector: </span>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    {{ item.desc_sector_empresa }}
                  </v-col>
                  <v-col cols="5" class="py-0">
                    <span class="font-weight-bold">Dirección: </span>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    {{ item.direccion_experiencia }}
                  </v-col>
                  <v-col cols="5" class="py-0">
                    <span class="font-weight-bold">Teléfono: </span>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    {{ item.telefono_experiencia }}
                  </v-col>
                  <v-col cols="5" class="py-0">
                    <span class="font-weight-bold">Función: </span>
                  </v-col>
                  <v-col cols="7" class="py-0">
                    {{ item.funcion_cargo }}
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center">
                    <span class="text--secondary">{{ item.fecha_inicio | filtroFecha }} -
                      {{ item.fecha_fin | filtroFecha }}</span>
                  </v-col>
                  <v-col cols="12" v-if="item.observacion_experiencia" class="d-flex justify-center">
                    {{ item.observacion_experiencia }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="2" xs="12">
                <v-row>
                  <v-col cols="6" md="12" sm="6" xs="6">
                    <TableButtonComp v-if="componenteEvento.editar_submodulo" @click="experienciaEdit(item)" editButton
                      tooltipText="Editar experiencia laboral" />

                  </v-col>
                  <v-col cols="6" md="12" sm="6" xs="6">
                    <TableButtonComp v-if="componenteEvento.borrar_submodulo" @click="experienciaOnDelete(item.id)"
                      deleteButton tooltipText="Eliminar experiencia laboral" />

                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-alert>
        </v-card>
      </v-col>
    </v-row>

    <!--modal agregar experiencia laboral -->
    <v-form ref="formExperiencia" lazy-validation>
      <ComunDialogComp v-model="modalExperiencia" max-width="650px" :title="titleExperiencia"
        @close-modal="modalExperiencia = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <textfieldComp textLabel="Empresa" v-model="experiencia.nombre_empresa" type="text"
                :rules="validationRules.max60" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp textLabel="Sector de la empresa" v-model="experiencia.id_sector_empresa"
                :items="getSectorEmpresa" item-value="id" item-text="desc_sector_empresa"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <textfieldComp textLabel="Cargo" v-model="experiencia.cargo_experiencia" type="text"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu9" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted9" label="Fecha de inicio" readonly v-on="on"
                    :rules="validationRules.validateCampo"></v-text-field>
                </template>

                <v-date-picker v-model="experiencia.fecha_inicio" no-title :max="emaxdate" @input="menu9 = false"
                  @change="set_emindate"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-menu v-model="menu10" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="computedDateFormatted10" label="Fecha de finalización" readonly v-on="on" :min="emindate"
                    :rules="validationRules.validateCampo"></v-text-field>
                </template>

                <v-date-picker v-model="experiencia.fecha_fin" no-title :min="emindate" @change="set_emaxdate"
                  @input="menu10 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <textfieldComp textLabel="Función" v-model="experiencia.funcion_cargo" type="text"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="">
              <textfieldComp textLabel="Teléfono de la empresa" v-model="experiencia.telefono_experiencia" type="number"
                :rules="validationRules.max20" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <textfieldComp textArea textLabel="Dirección de la empresa" v-model="experiencia.direccion_experiencia"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <textfieldComp textLabel="Observación" textArea v-model="experiencia.observacion_experiencia" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-row dense>
            <v-col cols="12" class="d-flex justify-end gap-10px">
              <TableButtonComp normalButton v-if="eventoExperiencia == 'editar'" @click="addItemExperiencia()"
                textButton="Guardar cambios" iconBut="fas fa-save" />
              <TableButtonComp v-if="eventoExperiencia == 'agregar'" @click="addItemExperiencia()" textButton="Guardar"
                iconBut="fas fa-save" normalButton />
              <TableButtonComp normalButton @click="modalExperiencia = false" textButton="Cancelar" classColor="red" />
            </v-col>
          </v-row>
        </template>
      </ComunDialogComp>
    </v-form>
    <!---->

    <confirm @cancelar="clear_confirm" @aceptar="experienciaDelete" :title="confirm.title" :active="confirm.active" />

    <span v-if="test">
      <code> Datos :{{ Datos }} </code>
      <code> Parametros :{{ parametros }} </code>
      <code> Persona :{{ persona }} </code>
      <code> Personal :{{ personal }} </code>
    </span>
    <!-- fin modal del Usuario -->
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import TableButtonComp from "@/components/ComponentsEst/TableButtonComp.vue";
import ComunDialogComp from "@/components/ComponentsEst/ComunDialogComp.vue";
import textfieldComp from "@/components/ComponentsEst/textfieldComp.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import { validationRules } from "@/helpers/validatorHelpers.js";

import { mapGetters, mapMutations } from "vuex";
import moment from "moment";

export default {
  name: "compIdioma",
  components: {
    TableButtonComp,
    ComunDialogComp,
    textfieldComp,
    AutocompleteComp,
  },

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },

  data: () => ({
    datoLogin: sessionStorage,
    session: sessionStorage, // variables de sesion del usuario
    rutaServer: API_URL,
    ////////////////////////////////////////////////////////

    Datos: [],
    test: false,
    bloquearInput: false,

    /* confirms */
    confirm: {
      id: 0,
      title: "",
      active: false,
      action: 0, // 1:personal, 2:formacion, 3:idiomas, 4:capacitacion, 5:experiencia, 6:seguro
    },

    InputUpdate: false,

    modalExperiencia: false,
    titleExperiencia: "",
    mensajeExperiencia: false,
    experiencia: [],
    experienciaItem: [],
    emaxdate: null,
    emindate: null,
    eventoExperiencia: "agregar",
    menu9: false,
    menu10: false,

    getSectorEmpresa: [],
  }),

  mounted() {
    this.loadMain();
  },

  //computadas
  computed: {
    validationRules() {
      return validationRules;
    },

    formTitle() {
      return this.parametros.evento === "agregar"
        ? "Crear Usuario"
        : "Editar Usuario";
    },

    ...mapGetters("login", ["componenteEvento"]),

    // Maxima Fecha Calendario fecha actual
    getEndDate() {
      return moment(new Date()).format("YYYY-MM-DD");
      //return new Date().toISOString().substr(0, 10);
    },

    computedDateFormatted9() {
      return this.formatDate(this.experiencia.fecha_inicio);
    },

    computedDateFormatted10() {
      return this.formatDate(this.experiencia.fecha_fin);
    },
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp: function () {
      if (this.estadoComp) {
        this.loadMain();
      } else {
        this.limpiarForm();
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //  ------- input tipo fecha  --------
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      this.limpiarForm();
      this.getQuery();
    },

    async getQuery() {
      this.actualizarItems();
      this.getAllSectorEmpresa();
    },

    //------------ MOSTRAR SECTOR EMPRESA -------------
    async getAllSectorEmpresa() {
      try {
        let response = await axios.get("/mantenimiento/sectorEmpresa");
        this.getSectorEmpresa = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    async actualizarItems() {
      try {
        let response = await axios.get(
          "/administrativo/personal/editarPersonal/" + this.parametros.item.id
        );
        this.experienciaItem = response.data.experiencia;

        if (this.experienciaItem.length === 0) {
          this.mensajeExperiencia = true;
        } else {
          this.mensajeExperiencia = false;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
        //console.log(error);
      }
    },

    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
      this.confirm.action = 0;
    },

    //---------obtener Datos pára editar
    async editItem(item) {
      this.bloquearInput = false;
      // this.Datos = Object.assign({}, item)
      console.log(item);
      this.personal = Object.assign({}, item);
      this.persona = Object.assign({}, item);
    },

    limpiarForm() {
      this.experiencia = {
        id_colegio: this.datoLogin.id_colegio,
        id_usuario: this.datoLogin.id,
        funcion_cargo: null,
        telefono_experiencia: null,
        observacion_experiencia: null,
        estado_experiencia: 1,
        eventoExperiencia: "agregar",
      };

      this.resetValidation();
    },

    resetValidation() {
      this.$refs.formExperiencia.resetValidation();
    },

    set_emindate() {
      this.emindate = this.experiencia.fecha_inicio;
    },

    set_emaxdate() {
      this.emaxdate = this.experiencia.fecha_fin;
    },

    //------------ MODAL DE EXPERIENCIA LABORAL -------------
    async modalAddExperiencia() {
      this.titleExperiencia = "Agregar experiencia laboral";
      this.eventoExperiencia = "agregar";
      this.modalExperiencia = true;
      this.limpiarForm();
    },

    //------------ AGREGAR ITEM DE EXPERICIENCIAS -------------
    addItemExperiencia() {
      this.formValidateExperiencia();
    },

    //----------- VALIDAR CAMPOS DEL FORMULARIO EXPERICIENCIAS  --------------
    async formValidateExperiencia() {
      if (this.$refs.formExperiencia.validate()) {
        try {
          this.experiencia.id_personal = this.parametros.item.id;
          this.experiencia.metodo = this.eventoExperiencia;
          let params = { experienciaLaboral: this.experiencia };
          let resp = {};
          if (this.eventoExperiencia == "agregar") {
            resp = await axios.post(
              "/administrativo/experienciaLaboral",
              params
            );
          }

          if (this.eventoExperiencia == "editar") {
            let id = this.experiencia.id;
            resp = await axios.put(
              "/administrativo/experienciaLaboral/" + id,
              params
            );
          }

          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: `¡Información creada con éxito!`,
            tiempo: null,
          });

          this.modalExperiencia = false;
          this.limpiarForm();

          this.actualizarItems();
        } catch (error) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error Interno Guardar`,
            tiempo: null,
          });
          //alert(error);
          //console.log(error);
        }
      }
    },

    experienciaEdit(item) {
      this.titleExperiencia = "Editar experiencia laboral";
      this.eventoExperiencia = "editar";
      this.modalExperiencia = true;
      this.limpiarForm();

      this.experiencia = Object.assign({}, item);
    },
    experienciaOnDelete(id) {
      this.confirm.title = "¿Está seguro que desea eliminar este registro?";
      this.confirm.id = id;
      this.confirm.action = 5;
      this.confirm.active = true;
    },
    async experienciaDelete() {
      try {
        await axios
          .delete("/administrativo/experienciaLaboral/" + this.confirm.id)
          .then(() => {
            this.actualizarItems();
            this.setEnviarMens({
              tipo: "S",
              mensaje: `Registro borrado con éxito`,
              tiempo: null,
            });
            this.clear_confirm();
          });
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `¡Información eliminada con éxito!`,
          tiempo: null,
        });
      }
    },

    //******************************************************************** */
  },
};
</script>

<style scoped>
.fondo_add_img {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  cursor: pointer;
  cursor: hand;
  border: 4px solid #fff;
  border-color: #474545;
  color: #524f4f;
}
</style>
